// Routing endpoints
export const TASKS_GET_METADATA = "/v0/tasks/getMetadata";
export const VIEWS_GET = "/v0/views/get";
export const WEB_HOST_GET = "/v0/hosts/web";

export const TASKS_GET_TASK_REVIEWERS = "/v0/tasks/getTaskReviewers";
export const RUNBOOKS_GET = "/v0/runbooks/get";
export const ENTITIES_SEARCH = "/v0/entities/search";
export const USERS_GET = "/v0/users/get";
export const GROUPS_GET = "/v0/groups/get";
export const PERMISSIONS_GET = "/v0/permissions/get";

export const REQUESTS_CREATE = "/v0/requests/create";
export const UPLOADS_CREATE = "/v0/uploads/create";
export const PICK_ZONE = "/v0/inputs/pickZone";
export const RUNNER_SCALE_SIGNAL_CREATE = "/v0/runners/createScaleSignal";

export const EVALUATE_TEMPLATE = "/v0/templates/evaluate";

export const AGENT_UPLOADS_CREATE = "/v0/dp/uploads/create";
